// 圖表相關通用翻譯
export default {
  // 系列名稱
  inflow: "轉入",
  outflow: "轉出",

  // Y軸單位
  unitTimes: "單位:(次)",
};
